import { useService } from 'react-reservice';

import { accountService } from './service';

export const useCheckIsOneClickTradingEnabled = () =>
  useService(accountService, (context) => context.isOneClickTradingEnabled);

export const useOneClickTradingLoading = () => useService(accountService, (context) => context.oneClickTradingLoading);
